import { useMutation, useQueryClient } from '@tanstack/react-query';
import { consultasKeys } from './use-consultas';
import { documentosKey } from './use-documentos';
import { apiClient } from '../../lib/api-client';
import type { EnvioCorreo } from '../../types/consultas';

/**
 * Envío del plan de pagos por correo (HU-C06) — aislado en su hook (patrón Web 05 §2.4) y conectado al
 * endpoint real de feat-31 en la integración del lote 02 (change-59):
 * `POST /api/v1/documents/versions/:versionId/envio` (`.work/payment-plan/feat-31-asesor-enviar-correo/contrato-api.md`).
 *
 * Al terminar refresca el historial (`['documentos', separacionId]`) y las consultas, que muestran
 * `versiones[].enviadoEn`. Los errores (404, 409 versión no vigente, 422 sin correos, 429, 502) llegan
 * con el `message` del back, ya redactado para el usuario.
 */
export function useEnviarCorreo(separacionId: string) {
  const queryClient = useQueryClient();
  return useMutation<EnvioCorreo, Error, string>({
    mutationFn: (versionId) => apiClient.documents.sendByEmail(versionId),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: documentosKey(separacionId) }),
        queryClient.invalidateQueries({ queryKey: consultasKeys.todas }),
      ]);
    },
  });
}

/** Confirmación visible del envío; en entornos sin proveedor real avisa que el correo no salió. */
export function mensajeDeEnvio(envio: EnvioCorreo): string {
  const destinatarios = envio.destinatarios.join(', ');
  if (envio.simulado) {
    return `Envío simulado de ${envio.consecutivo}: el correo no salió porque el envío real está desactivado en este entorno.`;
  }
  return `${envio.consecutivo} enviado a ${destinatarios}.`;
}
